import React, { useState, useEffect } from 'react';
import { Container, Badge, Button } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import moment from 'moment';
import { FaDownload } from 'react-icons/fa';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const NoticeDetail = () => {
  const { slug } = useParams();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNotice();
  }, [slug]);

  const loadNotice = async () => {
    try {
      const response = await api.get(`/notices/${slug}/`);
      setNotice(response.data);
    } catch (error) {
      console.error('Error loading notice:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!notice) {
    return (
      <Container className="py-5">
        <h1>Notice Not Found</h1>
        <Link to="/notices" className="btn btn-primary">Back to Notices</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <article>
        <h1>{notice.title}</h1>
        <div className="mb-3">
          <Badge bg="primary" className="me-2">{notice.notice_type}</Badge>
          {notice.is_new && <Badge bg="danger" className="me-2">New</Badge>}
          <span className="text-muted">
            Published: {moment(notice.published_date).format('MMMM DD, YYYY')}
          </span>
        </div>
        <div dangerouslySetInnerHTML={{ __html: notice.description }} />
        
        {notice.notice_file && (
          <div className="mt-4">
            <Button 
              variant="success" 
              href={getMediaUrl(notice.notice_file)} 
              target="_blank"
            >
              <FaDownload className="me-2" />
              Download Attachment
            </Button>
          </div>
        )}
      </article>
      <div className="mt-4">
        <Link to="/notices" className="btn btn-outline-primary">← Back to Notices</Link>
      </div>
    </Container>
  );
};

export default NoticeDetail;
